import { CSSProperties } from 'react';

export const getIconStyle = (): CSSProperties => ({
  display: 'flex',
  height: 12,
  width: 12,
  top: `calc(50% - 7px)`,
  right: 20,
});
